
define('require-css/css!js-css/tabs',[],function(){});
